module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "stats"
  }, [_h('div', {
    staticClass: "stats__line stats__line--feedback"
  }, [_h('button', {
    on: {
      "click": function($event) {
        share('twitter')
      }
    }
  }, ["Share on Twitter"])]), " ", _h('div', {
    staticClass: "stats__line stats__line--total"
  }, ["\n    " + _s(_f("number")((globalPoints || '20,000,000+'))) + "\n  "]), " ", _h('div', {
    staticClass: "stats__line stats__line--points"
  }, ["\n    " + _s(_f("number")(points)) + "\n  "])])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-009fef78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stats.vue
 ** module id = 160
 ** module chunks = 2
 **/